module.exports = __webpack_public_path__ + "img/TipperRoof-Assembly.59625ced.jpg";